'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../motion/index.js');
const drag = require('../../motion/features/drag.js');
const gestures = require('../../motion/features/gestures.js');
const exit = require('../../motion/features/exit.js');
const animation = require('../../motion/features/animation.js');
const Animate = require('../../motion/features/layout/Animate.js');
const Measure = require('../../motion/features/layout/Measure.js');
require('./utils/create-config.js');
const motionProxy = require('./motion-proxy.js');

var allMotionFeatures = [Measure.MeasureLayout, animation.Animation, drag.Drag, gestures.Gestures, exit.Exit, Animate.AnimateLayout];
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */
var motion = /*@__PURE__*/motionProxy.createMotionProxy(allMotionFeatures);

exports.motion = motion;
